<!-- Filter Date Range Component -->
<div class="flex flex-col gap-4 p-4">
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
    <!-- Min -->
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium text-neutral-800">{{
        'common.filter.dateRange.from' | translate
      }}</span>
      <input
        class="h-10 w-full rounded-md border border-neutral-300 bg-white px-3 text-sm text-neutral-900 transition-colors outline-none focus:border-neutral-900 focus:ring-2 focus:ring-neutral-900/20"
        (change)="onMinDateChange($event.target)"
        type="date"
      />
    </label>

    <!-- Max -->
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium text-neutral-800">{{
        'common.filter.dateRange.to' | translate
      }}</span>
      <input
        class="h-10 w-full rounded-md border border-neutral-300 bg-white px-3 text-sm text-neutral-900 transition-colors outline-none focus:border-neutral-900 focus:ring-2 focus:ring-neutral-900/20"
        (change)="onMaxDateChange($event.target)"
        type="date"
      />
    </label>
  </div>

  <p class="text-xs text-neutral-600">
    {{ 'common.filter.dateRange.description' | translate }}
  </p>
</div>
